
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$sticker.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$sticker.js';
export default __default__;
